import axios from 'axios';
import { useMemo, useState } from 'react';
import { ReactSession } from 'react-client-session';
import { useDidMount } from 'rooks';

import ServicePaths from '../bridge/utils/ServicePaths';
import { useSelector } from 'react-redux';
import { selectUserId } from '../store/slices/user';

export enum ProblemReason {
  GRTSProfitCalcsServiceOfflne = 'GRTS_SERVICE_PROFIT_CALCS_OFFLINE',
  GRTSCandleFetcherServiceOfflne = 'GRTS_SERVICE_CANDLE_FETCHER_OFFLINE',
  GRTSOrderServiceOfflne = 'GRTS_SERVICE_ORDER_OFFLINE',
  GRTSControlServiceOfflne = 'GRTS_SERVICE_CONTROL_OFFLINE',
  ActiveStatus = 'ACTIVE_STATUS',
  FetchingDataPending = 'FETCHING_DATA_PENDING',
  SyncStatus = 'SYNC_STATUS',
}

type Reason =
  | {
      baseAsset: string;
      botId: string;
      clusterId: string;
      reason: 'ACTIVE_STATUS';
    }
  | {
      baseAsset: string;
      subcriptionId: number;
      botId: string;
      clusterId: string;
      reason: 'SYNC_STATUS';
      extraInfo?: string;
    }
  | {
      reason: ProblemReason;
    };

type Health =
  | {
      isLoading: boolean;
      data: Array<Reason>;
      request: string; // AxiosPromise<any>;
    }
  | undefined;

/** Redux would fix these issues you know... */
const useHealthCheck = () => {
  const userId = useSelector(selectUserId);
  const health: Health = useMemo(() => ReactSession.get('health'), []);
  const [data, setData] = useState<any>();

  const savedData = useMemo(() => {
    return health?.data?.length ? health.data : undefined;
  }, [health]);

  useDidMount(async () => {
    ReactSession.set('health', {
      ...health,
      isLoading: true,
    });

    const { data } = await axios({
      url: ServicePaths.DATA.GetClientHealthCheck,
      method: 'POST',
      data: { userId },
    });

    setData(data);

    ReactSession.set('health', {
      ...health,
      isLoading: false,
      data: data.problems,
    });
  });

  const returnedData = useMemo(
    () => (data?.problems ?? savedData) as Array<Reason> | undefined,
    [data?.problems, savedData],
  );

  return {
    data: returnedData,
  };
};

export default useHealthCheck;

export const isFetchingCandles = (data: Array<Reason>) =>
  !!data.find((r) => r.reason === 'FETCHING_DATA_PENDING');
